/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseRegistrationManagementMonographViewModel } from "../types/CourseRegistrationManagementMonographViewModel.ts";
import { eMonographPresentationStatusSchema } from "./eMonographPresentationStatusSchema.ts";

export const courseRegistrationManagementMonographViewModelSchema = z.object({
  personName: z.string().describe("Nome da pessoa matriculada.").nullish(),
  personEmail: z.string().describe("E-mail da pessoa matriculada.").nullish(),
  personAlias: z.string().nullish(),
  personId: z.optional(z.number().int().describe("ID da pessoa matriculada.")),
  classStudentName: z.string().describe("Nome da turma.").nullish(),
  classStudentId: z.optional(z.number().int().describe("ID da turma.")),
  courseName: z.string().describe("Nome do curso.").nullish(),
  courseId: z.optional(z.number().int().describe("ID do curso.")),
  poloName: z
    .string()
    .describe("Nome do polo vinculado à matrícula. Opcional.")
    .nullish(),
  poloId: z
    .number()
    .int()
    .describe("ID do polo vinculado à matrícula. Opcional.")
    .nullish(),
  monographId: z
    .number()
    .int()
    .describe("ID da monografia associada. Opcional.")
    .nullish(),
  monographTheme: z
    .string()
    .describe("Tema da monografia. Opcional.")
    .nullish(),
  monographEventRoomName: z.string().nullish(),
  monographBoardMembers: z.array(z.string()).nullish(),
  presentationId: z
    .number()
    .int()
    .describe("ID da apresentação da monografia. Opcional.")
    .nullish(),
  scheduleStartDatetime: z
    .string()
    .datetime()
    .describe("Data e hora agendada para a apresentação. Opcional.")
    .nullish(),
  scheduleEndDatetime: z.string().datetime().nullish(),
  presentationStatus: z.optional(
    z
      .lazy(() => eMonographPresentationStatusSchema)
      .describe(
        "0 = Uninformed | 1 = PendingAction | 2 = Confirmed | 3 = AwaitingStudentAcceptance | 4 = Approved | 5 = Failed | 6 = Cancelled | 7 = TemporarilyReproved | ",
      ),
  ),
  presentationGrade: z
    .number()
    .describe("Nota da apresentação da monografia. Opcional.")
    .nullish(),
  examGrade: z
    .number()
    .describe("Nota da avaliação escrita da monografia. Opcional.")
    .nullish(),
  toRevision: z.optional(
    z.boolean().describe("Indica se a monografia está em processo de revisão."),
  ),
  toLibrary: z.optional(z.boolean()),
}) as unknown as ToZod<CourseRegistrationManagementMonographViewModel>;
